import { matchCountryUrlOrigin } from './match-url-pattern';

/**
 * Checks if the given URL matches the tier one URL.
 *
 * @param {string} tierOneUrl - The tier one URL or Country domain url (e.g. https://www.audi.de).
 * @param {string} [url] - The URL to check. If not provided, the current URL will be used.
 * @return {boolean} - True if the URL matches the tier one URL, false otherwise.
 */
export function isDealerDomain(tierOneUrl: string, url?: string): boolean {
  if (typeof window !== 'undefined') {
    const currentUrl = url || window.location.href;

    const boolDealerDomain = matchCountryUrlOrigin(tierOneUrl || '', currentUrl);

    return boolDealerDomain;
  }

  return false;
}
